import { rootElementId } from '../app.config';

const isVerificationUpsellModalEnbaled = () => {
  const element = document.getElementById(rootElementId);
  if (element && element.dataset) {
    return element.dataset.isVerificationUpsellEnabled === 'true';
  }
  return element.getAttribute('data-is-verification-upsell-enabled') === 'true';
};

export default isVerificationUpsellModalEnbaled;
